module.exports = __webpack_public_path__ + "img/9.a958f01f.jpeg";